import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { generateQeId, Tag } from '@ctct/ui-react';

const propTypes = {
  'data-qe-id': PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  large: PropTypes.bool,
  specificSize: PropTypes.string,
};

const defaultProps = {
  large: false,
  specificSize: null,
};

const RecommendedBadge = (props) => {
  const { 'data-qe-id': qeId, large, specificSize, t } = props;

  const tagSize = useMemo(() => {
    if (specificSize) return specificSize;

    return large ? 'large' : 'default';
  }, [specificSize, large]);

  return (
    <span className="recommended-badge-v2">
      <Tag
        kind="featured"
        size={tagSize}
        text={t('comparison-table.recommended')}
        data-qe-id={generateQeId(qeId, 'recommended-badge')}
      />
    </span>
  );
};

RecommendedBadge.propTypes = propTypes;
RecommendedBadge.defaultProps = defaultProps;
export default RecommendedBadge;
